import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxFileDropModule } from 'ngx-file-drop';
import { SharedModule } from 'src/app/shared/shared.module';
import { RenderDropZoneComponent } from './drop-zone/render-drop-zone.component';
import { RenderFeedbackDialogComponent } from './feedback-dialog/render-feedback-dialog.component';
import { RenderRatingComponent } from './feedback-dialog/render-rating.component';
import { RenderVoteComponent } from './feedback-dialog/render-vote.component';
import { RenderPackCardComponent } from './pack-card/render-pack-card.component';
import { RenderSampleCardComponent } from './sample-card/render-sample-card.component';
import { RenderLibraryFilterComponent } from './library/render-library-filter.component';
import { RenderPackDialogComponent } from './pack-dialog/render-pack-dialog.component';
import { RenderHelpDialogComponent } from './help-dialog/render-help-dialog.component';
import { RenderLeaveDialogComponent } from './leave-dialog/render-leave-dialog.component';
import { RenderLibraryComponent } from './library/render-library.component';
import { RenderLegalComponent } from './legal/render-legal.component';
import { RenderAccountService } from './render-account.service';
import { renderLive } from 'src/app/shared/feature-flags';
import { MockRenderBackend, RenderBackend } from './render-backend';
import { FirestoreRenderBackend } from './render-firestore-backend';
import { RenderFlowShellComponent } from './render-flow-shell/render-flow-shell.component';
import { RenderFeedbackService } from './render-feedback.service';
import { RenderFlowService } from './render-flow.service';
import { RenderHelpService } from './render-help.service';
import { RenderNotifyService } from './render-notify.service';
import { RenderPackService } from './render-pack.service';
import { RenderProfileMenuComponent } from './profile-menu/render-profile-menu.component';
import { RenderVeilDirective } from './render-veil.directive';
import { RenderLandingV2Component } from './render-landing-v2/render-landing-v2.component';
import { RenderCheckoutStepComponent } from './steps/render-checkout-step.component';
import { RenderConfirmingStepComponent } from './steps/render-confirming-step.component';
import { RenderDownloadsStepComponent } from './steps/render-downloads-step.component';
import { RenderErrorStepComponent } from './steps/render-error-step.component';
import { RenderPreviewStepComponent } from './steps/render-preview-step.component';
import { RenderProgressStepComponent } from './steps/render-progress-step.component';
import { RenderUploadStepComponent } from './steps/render-upload-step.component';
import { RenderStillDevicesComponent } from './still-devices/render-still-devices.component';
import { RenderUnlockDialogComponent } from './unlock-dialog/render-unlock-dialog.component';

// The render product: landing + the upload → preview → purchase → download flow under /render,
// and "Your library" (routes in web-routing.module.ts, behind the `renderLanding` flag). Eager like
// the discover landing — a lazy module cannot import SharedModule (BrowserAnimationsModule), and the topbar
// and the dialogs live there. See docs/render-landing-port.md.
//
// RenderBackend decides what the flow talks to: with the `renderLive` flag, FirestoreRenderBackend —
// real uploads, renders, Stripe checkout and the ZIP pack on the render backend; without it,
// MockRenderBackend simulates everything in the browser.
@NgModule({
  declarations: [
    RenderLandingV2Component,
    RenderFlowShellComponent,
    RenderUploadStepComponent,
    RenderProgressStepComponent,
    RenderPreviewStepComponent,
    RenderCheckoutStepComponent,
    RenderConfirmingStepComponent,
    RenderDownloadsStepComponent,
    RenderErrorStepComponent,
    RenderLibraryComponent,
    RenderLibraryFilterComponent,
    RenderDropZoneComponent,
    RenderStillDevicesComponent,
    RenderUnlockDialogComponent,
    RenderLeaveDialogComponent,
    RenderFeedbackDialogComponent,
    RenderRatingComponent,
    RenderVoteComponent,
    RenderPackCardComponent,
    RenderSampleCardComponent,
    RenderPackDialogComponent,
    RenderHelpDialogComponent,
    RenderProfileMenuComponent,
    RenderVeilDirective,
    RenderLegalComponent,
  ],
  imports: [CommonModule, RouterModule, NgxFileDropModule, SharedModule],
  providers: [
    RenderFlowService,
    RenderPackService,
    RenderNotifyService,
    RenderAccountService,
    RenderHelpService,
    RenderFeedbackService,
    { provide: RenderBackend, useClass: renderLive ? FirestoreRenderBackend : MockRenderBackend },
  ],
})
export class RenderModule {}
